/**
 * The key in the application global where we store the current auth token.
 * @type {string}
 */
export const GLOBAL_ACCESS_TOKEN_KEY = 'fenix/authentication/accessToken';

export const SSO_VALIDATE_PATH = '/login/sso';

// Redux actions
export const DECODE_AUTH_TOKEN = 'fenix/authentication/DECODE_AUTH_TOKEN';
export const REFRESH_AUTH_TOKEN = 'fenix/authentication/REFRESH_AUTH_TOKEN';
export const LOGIN_SUCCESS = 'fenix/authentication/LOGIN_SUCCESS';
export const LOGOUT = 'fenix/authentication/LOGOUT';
export const SET_DEFAULT_OEM = 'fenix/authentication/SET_DEFAULT_OEM';
export const TICKET_VALIDATION_FAILURE = 'fenix/authentication/TICKET_VALIDATION_FAILURE';
export const VALIDATE_SSO_TICKET = 'fenix/authentication/VALIDATE_SSO_TICKET';



// WEBPACK FOOTER //
// ./features/authentication/constants.js